module.exports = __webpack_public_path__ + "static/media/square.bcef7caf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/square.svg
// module id = 227
// module chunks = 0